import { render, staticRenderFns } from "./tournamentTeams.vue?vue&type=template&id=8b3e2cbe&scoped=true&"
import script from "./tournamentTeams.vue?vue&type=script&lang=js&"
export * from "./tournamentTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e2cbe",
  null
  
)

export default component.exports